import { Point } from 'google-map-react';

export function customDistanceToMouse(point?: Point, mousePos?: Point) {
  // In reality point and mousePos could be undefined but googleMap types say they are not optional
  if (!point || !mousePos) {
    return 0;
  }

  const { x, y } = point;

  return Math.sqrt(
    (x - mousePos.x) * (x - mousePos.x) + (y - mousePos.y) * (y - mousePos.y),
  );
}
